import { render, staticRenderFns } from "./horizontalBarChart.vue?vue&type=template&id=f0a8ead2&"
import script from "./horizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./horizontalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports